import {
  getCurrentLocaleCode,
  setLocalizationConfigurations,
} from "@mongez/localization";
import { jsxConverter } from "@mongez/react-localization";
import { AppDirection } from "core/shared";

export const supportedLanguages = ["en", "ar"];

export type Language = (typeof supportedLanguages)[number];

export const returnLanguageIfSupported = (
  lang?: string,
): Language | undefined => {
  if (supportedLanguages.includes(lang as Language)) {
    return lang as Language;
  }
  return undefined;
};

setLocalizationConfigurations({
  converter: jsxConverter,
  defaultLocaleCode: "en",
});

export const isRTL = () => getCurrentLocaleCode() === "ar";
export const isLTR = () => getCurrentLocaleCode() === "en";
export const currentDirection = (): AppDirection =>
  (isRTL() ? "rtl" : "ltr") as AppDirection;
